import DarkMode from "@mui/icons-material/DarkMode";
import LightMode from "@mui/icons-material/LightMode";
import { useMemo } from "react";

import { DropdownMenu } from "@moment/design-system/DropdownMenu";
import { useTheme } from "@moment/design-system/ThemeProvider";

import { isRunningInIframe, sendPostMessage } from "~/utils/iframe";

import { IconButton } from "../Button";

export function ThemeSwitcher() {
	const { resolvedTheme, theme: selectedTheme, setTheme, themes } = useTheme();
	// FIXME: Figure out why this is necessary.
	const uniqueThemes = useMemo(() => {
		return [...new Set(themes)];
	}, [themes]);

	const wrappedSetTheme = (theme: string) => {
		setTheme(theme);
		if (isRunningInIframe()) {
			sendPostMessage("setTheme", { theme });
		}
	};

	return (
		<DropdownMenu.Root>
			<DropdownMenu.Trigger asChild>
				<IconButton
					preset="quaternary"
					icon={resolvedTheme === "light" ? <LightMode /> : <DarkMode />}
					label="Theme"
				></IconButton>
			</DropdownMenu.Trigger>
			<DropdownMenu.Portal>
				<DropdownMenu.Content>
					{uniqueThemes.map((theme) => (
						<DropdownMenu.CheckboxItem
							key={theme}
							checked={theme === selectedTheme}
							onSelect={() => wrappedSetTheme(theme)}
						>
							{theme}
						</DropdownMenu.CheckboxItem>
					))}
				</DropdownMenu.Content>
			</DropdownMenu.Portal>
		</DropdownMenu.Root>
	);
}
